// extracted by mini-css-extract-plugin
export var chevronIcon = "_5x-2";
export var teamName = "_5x-1";
export var teamSwitcherButton = "_5x-0";